import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import {
  trackEvent,
  trackPageView,
  trackButtonClick,
  trackFormSubmission,
  trackSocialShare,
  trackWaitlistSignup,
  trackNavigation,
  trackContactForm,
  trackUserInteraction,
  initGA,
  setAnalyticsConsent
} from '@/utils/analytics';
import { useCookieConsent } from '@/context/CookieConsentContext';

export const useAnalytics = () => {
  const location = useLocation();
  const { preferences, hasConsented } = useCookieConsent();

  // Initialize analytics when consent changes
  useEffect(() => {
    if (hasConsented) {
      initGA(preferences.analytics);
      setAnalyticsConsent(preferences.analytics);
    }
  }, [preferences.analytics, hasConsented]);

  // Track page views on route changes (only if analytics consent given)
  useEffect(() => {
    if (preferences.analytics) {
      trackPageView(location.pathname + location.search, document.title);
    }
  }, [location, preferences.analytics]);

  return {
    trackEvent,
    trackButtonClick: useCallback((buttonName: string, location?: string) => {
      trackButtonClick(buttonName, location);
    }, []),
    trackFormSubmission: useCallback((formName: string, success: boolean = true) => {
      trackFormSubmission(formName, success);
    }, []),
    trackSocialShare: useCallback((platform: string, content?: string) => {
      trackSocialShare(platform, content);
    }, []),
    trackWaitlistSignup: useCallback((email: string) => {
      trackWaitlistSignup(email);
    }, []),
    trackNavigation: useCallback((destination: string, source?: string) => {
      trackNavigation(destination, source);
    }, []),
    trackContactForm: useCallback((formType: string, success: boolean = true) => {
      trackContactForm(formType, success);
    }, []),
    trackUserInteraction: useCallback((interactionType: string, details?: string) => {
      trackUserInteraction(interactionType, details);
    }, []),
  };
};